import React from "react";
import ReactDOM from 'react-dom/client';
import { useNavigate, Navigate } from 'react-router-dom';
import './App.css';
import { useEffect, useState, useRef } from 'react'
import AppLayout from './components/AppLayout';
import { get } from '@aws-amplify/api';
import awsconfig from './aws-exports';
import { printConsole } from './lib/utility'; 

import {
  Button,
  Flex,
  Heading,
  Text,
  TextField,
  View,
  withAuthenticator,
} from "@aws-amplify/ui-react";
import { type } from "@testing-library/user-event/dist/type";

import { AgGridReact } from "ag-grid-react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';


const myAPI="mktappapi";
let path = '/getsettings';

const List = ({ signOut }) => {
  printConsole("I am in List");
  const navigate = useNavigate();

  const [rowDataState,setRowDataSate]=useState([]);
  let analysis = useRef([]);

  let initString="";

  async function downloadStocks() {
    printConsole("Executing downloadStocks");
    path = '/getListEtfs';
    var passApiStr=await path;
    await console.log("downloadStocks : passApiStr = "+ passApiStr);
    /*await Promise.resolve(await get(myAPI, passApiStr))
      .then(async resp =>{
        await printConsole("downloadStocks : received symbols details = ");
        await console.log(resp);
        analysis.current = await resp;
    })*/
    const response = await get({
      apiName: myAPI,
      path: passApiStr,
    }).response
    .catch(error => {
      console.log("downloadStocks : error = ", error.message);
    });
    analysis.current = await response.body.json();
    await console.log("downloadStocks : analysis.current = ", analysis.current);
  }

  async function printStocks() {
    printConsole("Executing printStocks");
    try {
      await downloadStocks()
      .then(() => {
        if (analysis.current && analysis.current.length > 0) {
          const rowdata = analysis.current.map((item) => ({
            symbol: item.symbol,
            type: item.type,
            name: item.name,
            exchange: item.exchange,
            leveraged: item.leveraged,
          }));
    
          console.log("printStocks: Row Data:", rowdata); // Debug rowData before updating state
          setRowDataSate(rowdata); // Update state with row data
        } else {
          console.warn("printStocks: No data available in analysis.current");
        }
      })
      
    } catch (error) {
      console.error("Error in printStocks:", error.message);
    }
  }

  function getSymInfo(symbol) {
    let info = {};
    let name = "";
    let description = "";
    let exchange = "";
    let leveraged = "";
    let type = "";
    for (var symInd = 0; symInd < analysis.current.length; symInd++) {
      let dbSymbol = analysis.current[symInd]["symbol"].toString();
      if (dbSymbol === symbol) {
        exchange = analysis.current[symInd]["exchange"].toString();
        name = analysis.current[symInd]["name"].toString();
        type = analysis.current[symInd]["type"].toString();
        leveraged = analysis.current[symInd]["leveraged"].toString();
        symInd = analysis.current.length;
      }
    }
    info = {"symbol":symbol, "name":name, "type":type, "exchange":exchange, "leveraged":leveraged};
    return info;
  }

  function escapeHtml(unsafe) {
    return unsafe.replace(/[&<"']/g, match => ({
        '&': '&amp;',
        '<': '&lt;',
        '"': '&quot;',
        "'": '&#39;'
    }[match]));
  }

  class CustomCellRenderer extends React.Component {
    render() {
      const { value, data } = this.props; // value is the cell value, data is the entire row
      console.log("Renderer Props: ", this.props); // Log all props for debugging

      // If value is undefined, log a fallback error message
      if (!value) {
        console.error("CustomCellRenderer: 'value' is undefined for the current cell.");
        return null;
      }

      const safeValueSymbol = escapeHtml(value);
      const info = getSymInfo(safeValueSymbol);
      const exchange = info.exchange || "N/A";
      const leveraged = info.leveraged || "N/A";
      const name = escapeHtml(info.name || "Unknown");

      const safeValueExchange = escapeHtml(exchange);

      return (
        <a
          href={`https://www.google.com/finance/quote/${safeValueSymbol}:${safeValueExchange}?window=1Y`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#2563eb',
            textDecoration: 'none',
            fontWeight: '600',
            fontSize: '14px'
          }}
        >
          {safeValueSymbol}
        </a>
      );
    }
  }

  // Badge/Chip renderer for Type column
  class TypeBadgeRenderer extends React.Component {
    render() {
      const { value } = this.props;
      if (!value) return null;

      const getTypeColor = (type) => {
        const typeStr = type.toString().toUpperCase();
        if (typeStr.includes('ETF')) return { bg: 'rgba(59, 130, 246, 0.1)', color: '#3b82f6', border: 'rgba(59, 130, 246, 0.3)' };
        if (typeStr.includes('STOCK')) return { bg: 'rgba(16, 185, 129, 0.1)', color: '#10b981', border: 'rgba(16, 185, 129, 0.3)' };
        if (typeStr.includes('INDEX')) return { bg: 'rgba(245, 158, 11, 0.1)', color: '#f59e0b', border: 'rgba(245, 158, 11, 0.3)' };
        return { bg: 'rgba(107, 114, 128, 0.1)', color: '#6b7280', border: 'rgba(107, 114, 128, 0.3)' };
      };

      const colors = getTypeColor(value);

      return (
        <span style={{
          display: 'inline-block',
          padding: '4px 12px',
          borderRadius: '12px',
          fontSize: '12px',
          fontWeight: '500',
          backgroundColor: colors.bg,
          color: colors.color,
          border: `1px solid ${colors.border}`,
        }}>
          {value}
        </span>
      );
    }
  }

  // Badge/Chip renderer for Leveraged column
  class LeveragedBadgeRenderer extends React.Component {
    render() {
      const { value } = this.props;
      if (!value) return null;

      const valueStr = value.toString().toUpperCase();
      const isYes = valueStr === 'YES' || valueStr === 'Y' || valueStr === '1';

      const colors = isYes
        ? { bg: 'rgba(239, 68, 68, 0.1)', color: '#ef4444', border: 'rgba(239, 68, 68, 0.3)' }
        : { bg: 'rgba(107, 114, 128, 0.1)', color: '#6b7280', border: 'rgba(107, 114, 128, 0.3)' };

      return (
        <span style={{
          display: 'inline-block',
          padding: '4px 12px',
          borderRadius: '12px',
          fontSize: '12px',
          fontWeight: '500',
          backgroundColor: colors.bg,
          color: colors.color,
          border: `1px solid ${colors.border}`,
        }}>
          {isYes ? 'Yes' : 'No'}
        </span>
      );
    }
  }

  const columns = [
    {
      headerName: "Symbol",
      field: "symbol",
      sortable: true,
      filter: true,
      width: 120,
      resizable: true,
      cellRenderer: CustomCellRenderer,
    },
    {
      headerName: "Type",
      field: "type",
      sortable: true,
      filter: true,
      width: 130,
      resizable: true,
      cellRenderer: TypeBadgeRenderer,
    },
    {
      headerName: "Full Name",
      field: "name",
      sortable: true,
      filter: true,
      flex: 1,
      minWidth: 300,
      resizable: true
    },
    {
      headerName: "Exchange",
      field: "exchange",
      sortable: true,
      filter: true,
      width: 120,
      resizable: true
    },
    {
      headerName: "Leveraged",
      field: "leveraged",
      sortable: true,
      filter: true,
      width: 130,
      resizable: true,
      cellRenderer: LeveragedBadgeRenderer,
    },
  ];

useEffect(()=>{
  Promise.resolve(printStocks())
    .then(() => {
      console.log("rowDataState:", rowDataState); // Ensure this contains data
    })
    .catch((error) => {
      console.error("Error in printStocks:", error.message);
    });

},[])


  return (
    <AppLayout signOut={signOut}>
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '24px' }}>
        <div style={{ marginBottom: '24px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'rgba(0, 0, 0, 0.9)', marginBottom: '8px' }}>
            List Of ETFs
          </h1>
          <p style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.6)' }}>
            Browse and search through available ETFs
          </p>
        </div>

        <div
          className="ag-theme-quartz"
          style={{
            height: 'calc(100vh - 250px)',
            width: '100%',
            '--ag-header-height': '48px',
            '--ag-row-height': '52px',
            '--ag-header-background-color': 'rgba(249, 250, 251, 1)',
            '--ag-odd-row-background-color': 'rgba(255, 255, 255, 1)',
            '--ag-row-background-color': 'rgba(255, 255, 255, 1)',
            '--ag-row-hover-color': 'rgba(59, 130, 246, 0.05)',
            '--ag-border-color': 'rgba(229, 231, 235, 1)',
            '--ag-header-foreground-color': 'rgba(55, 65, 81, 1)',
            '--ag-foreground-color': 'rgba(17, 24, 39, 1)',
            '--ag-font-size': '14px',
            '--ag-cell-horizontal-padding': '16px',
            borderRadius: '8px',
            border: '1px solid rgba(229, 231, 235, 1)',
            overflow: 'hidden'
          }}
        >
          <AgGridReact
            rowData={rowDataState}
            columnDefs={columns}
            defaultColDef={{
              sortable: true,
              filter: true,
              resizable: true,
            }}
            pagination={true}
            paginationPageSize={20}
            suppressCellFocus={true}
            animateRows={true}
          />
        </div>
      </div>
    </AppLayout>
  );
};

export default withAuthenticator(List);